import api from "api";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { UpdateReferralParams } from "./types";

const useUpdateReferral = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, field, value }: UpdateReferralParams) =>
      api.call(`/uk/referral_tracking/${id}`, {
        method: "PATCH",
        data: { [field]: value },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.ukReferralTracking());
      },
    }
  );
};

export default useUpdateReferral;
